<ion-header [translucent]="true">
  <ion-toolbar>
    @if(state.isMobile){
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        <ion-icon size="large" name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    }

    <ion-buttons slot="end">
      @if(state.isApplicationAdmin){
      <ion-button (click)="changeViewer()">
        <ion-icon size="large" name="reader-outline"></ion-icon>
      </ion-button>
      } @if(!isPdf && state.isMobile){

      <ion-button (click)="download()">
        <ion-icon size="large" name="download-outline"></ion-icon>
      </ion-button>

      }@if(!state.isMobile){

      <ion-button (click)="cancel()">
        <ion-icon size="large" name="close-outline"></ion-icon>
      </ion-button>
      }
    </ion-buttons>
    <ion-title> {{ this.name }} </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true" [scrollY]="false" forceOverscroll="false">
  @if(docIds.length > 1){
  <ion-button
    class="navigation-button navigation-button-left"
    fill="clear"
    (click)="previousImage()"
    [disabled]="!hasPreviousImage()"
  >
    <ion-icon slot="icon-only" name="chevron-back-outline">
    </ion-icon> </ion-button
  >} @if (docLoaded) {
  <lib-viewer
    [docId]="this.currentNodeItemId"
    [docName]="this.name"
    [fileExtension]="this.fileExtension"
    [pdfType]="this.pdfType"
  ></lib-viewer>
  @if(!isPdf && captureDateString){
  <span class="capture-date">
    {{ captureDateString }}
  </span>
  } } @if(docIds.length > 1){
  <ion-button
    class="navigation-button navigation-button-right"
    fill="clear"
    (click)="nextImage()"
    [disabled]="!hasNextImage()"
  >
    <ion-icon slot="icon-only" name="chevron-forward-outline"> </ion-icon>
  </ion-button>
  }
</ion-content>
